import { render } from "./VabenePagesListPage.vue?vue&type=template&id=2b98998e&scoped=true&ts=true"
import script from "./VabenePagesListPage.vue?vue&type=script&lang=ts"
export * from "./VabenePagesListPage.vue?vue&type=script&lang=ts"

import "./VabenePagesListPage.vue?vue&type=style&index=0&id=2b98998e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b98998e"]])

export default __exports__